import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "adoption-search-print-button",
  class AdoptionSearchPrintButton extends WYATTElement {
    get templates() {
      return {
        printButton: document.getElementById("adoption-search-print-button")
          .content,
      };
    }

    handlePrintButtonClick() {
      window.print();
    }

    render() {
      const template = this.templates.printButton.cloneNode(true);

      this.appendChild(template);

      const buttonElement = this.querySelector("[data-print-button]");

      buttonElement.addEventListener(
        "click",
        this.handlePrintButtonClick.bind(this)
      );
    }
  }
);
